import { createContext, useEffect, useState } from "react";
import API from "../api/Api";

export const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [hero, setHero] = useState(null);
  const [visionMission, setVisionMission] = useState(null);
  const [siteSetting, setSiteSetting] = useState(null); 
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const loadData = async () => {
      try {
        const heroRes = await API.get("/hero_section");
        setHero(heroRes.data.data);

        const vmRes = await API.get("/vision-mission");
        setVisionMission(vmRes.data.data);

        const settingsRes = await API.get("/site_setting");
        setSiteSetting(settingsRes.data.data);

      } catch (err) {
        console.error("Context API Error:", err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  return (
    <AppContext.Provider
      value={{ hero, visionMission, siteSetting, loading }}
    >
      {children}
    </AppContext.Provider>
  );
};
